import React from "react";
import { Navigate } from "react-router-dom";
import localStorageAccessor from "@utility/local-storage-accessor";
const PublicRoute = ({ children }) => {
    const isAuthenticated = localStorageAccessor.isAuthenticated();
    if (isAuthenticated) {
        return React.createElement(Navigate, { to: "/dashboard", replace: true });
    }
    return React.createElement(React.Fragment, null, children);
};
export default PublicRoute;
